export type ModalErrorReason =
  | 'collision'
  | 'namespace'
  | 'unresolved'
  | 'load'
  | 'render'
  | 'close'
  | 'duplicate-package';

export interface ModalErrorContext {
  reason: ModalErrorReason;
  modalType?: string;
  modalId?: string;
  source?: string;
}

export type ModalErrorReporter = (error: unknown, context: ModalErrorContext) => void;

export type ModalErrorLogger = (message: string, error: unknown) => void;

export interface ModalErrorReporterOptions {
  reportError?: ModalErrorReporter;
  logError?: ModalErrorLogger;
}

export const createModalErrorReporter =
  ({ reportError, logError }: ModalErrorReporterOptions = {}): ModalErrorReporter =>
  (error, context) => {
    logError?.(context.modalType ? `${context.reason}: ${context.modalType}` : context.reason, error);

    reportError?.(error, context);
  };
